Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSharedStyles = void 0;
var _styles = require("../../../../styles");
var useSharedStyles = exports.useSharedStyles = function useSharedStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    focused = _STYLES$useStyles.focused,
    disabled = _STYLES$useStyles.disabled,
    fontSemiBold = _STYLES$useStyles.fontSemiBold;
  var sharedStyles = {
    label: Object.assign({}, fontSemiBold, {
      overflow: 'hidden',
      textAlign: 'center',
      maxWidth: _styles.STYLES.grid.maxInputWidth,
      alignItems: 'center',
      justifyContent: 'center'
    }),
    label_small: {
      borderRadius: (0, _styles.getREM)(2.1875 / 2),
      fontSize: _styles.STYLES.fontSize.s,
      lineHeight: _styles.STYLES.lineHeight.s,
      paddingTop: (0, _styles.getREM)(0.4375),
      paddingRight: (0, _styles.getREM)(0.75),
      paddingBottom: (0, _styles.getREM)(0.4375),
      paddingLeft: (0, _styles.getREM)(0.75)
    },
    label_normal: {
      borderRadius: (0, _styles.getREM)(2.5 / 2),
      fontSize: _styles.STYLES.fontSize.normal,
      lineHeight: _styles.STYLES.lineHeight.normal,
      paddingTop: (0, _styles.getREM)(0.5),
      paddingRight: (0, _styles.getREM)(1),
      paddingBottom: (0, _styles.getREM)(0.5),
      paddingLeft: (0, _styles.getREM)(1)
    },
    label_large: {
      borderRadius: (0, _styles.getREM)(3.75 / 2),
      fontSize: _styles.STYLES.fontSize.normal,
      lineHeight: _styles.STYLES.lineHeight.normal,
      paddingTop: (0, _styles.getREM)(0.84375),
      paddingRight: (0, _styles.getREM)(1.25),
      paddingBottom: (0, _styles.getREM)(0.84375),
      paddingLeft: (0, _styles.getREM)(1.25)
    },
    disabled: disabled,
    focused: focused
  };
  return {
    sharedStyles: sharedStyles
  };
};